import React from "react";
import { observer, inject } from "mobx-react";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";

import ButtonWithConfirmation from "../common_components/ButtonWithConfirmation";

@injectIntl
@inject("rootStore")
@observer
export default class TodosDeleteButton extends React.Component {
  constructor(props) {
    super(props);

    this.canDeleteTodoList = props.rootStore.authorizationStore.canDeleteTodoList(
      props.note
    );
  }

  render() {
    const { intl, note, onDelete } = this.props;
    const { formatMessage } = intl;

    const confirmation = formatMessage({ id: "are_you_sure_delete_checklist" });
    const okLabel = formatMessage({ id: "delete_all_items" });
    const cancelLabel = formatMessage({ id: "cancel" });

    return (
      <ButtonWithConfirmation
        confirmationMessage={confirmation}
        option1Label={cancelLabel}
        option2Label={okLabel}
        onOption2Select={onDelete}
        dropdownClassname="note-todo-delete-button"
        disabled={!this.canDeleteTodoList}
      >
        {okLabel}
      </ButtonWithConfirmation>
    );
  }
}

TodosDeleteButton.propTypes = {
  note: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired
};
